<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path d="M6 1C3.23858 1 1 3.23858 1 6C1 6.27614 0.776142 6.5 0.5 6.5C0.223858 6.5 0 6.27614 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.79253 11.2139 9.40094 9.96862 10.5H11C11.2761 10.5 11.5 10.7239 11.5 11C11.5 11.2761 11.2761 11.5 11 11.5H8.5C8.22386 11.5 8 11.2761 8 11V10.911C7.99986 10.9041 7.99986 10.8973 8 10.8904V8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5V10.0005C10.215 9.08782 11 7.63527 11 6C11 3.23858 8.76142 1 6 1ZM4 6C4 4.89543 4.89543 4 6 4C7.10457 4 8 4.89543 8 6C8 7.10457 7.10457 8 6 8C4.89543 8 4 7.10457 4 6ZM6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5Z" />
  </svg>
</template>
